module.exports = __webpack_public_path__ + "img/activity_title.124b45c6.png";